import { render, staticRenderFns } from "./MatriculasAtivasPorUnidade.vue?vue&type=template&id=79184493&scoped=true"
import script from "./MatriculasAtivasPorUnidade.vue?vue&type=script&lang=js"
export * from "./MatriculasAtivasPorUnidade.vue?vue&type=script&lang=js"
import style0 from "./MatriculasAtivasPorUnidade.vue?vue&type=style&index=0&id=79184493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79184493",
  null
  
)

export default component.exports